import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {GlobalSettingsService} from '../../services/ui/global-settings.service';
import {JobProcedureFormValidationsSkipRequestDetails} from '../../models/jobProcedureFormValidationsSkipRequestDetails';
import { ButtonIcons } from '../action-button/models/button-icons.enum';
import {fadeIn, fadeOut, slideDown, slideUp} from '../../animations';
import {JobProcedureService} from '../../services/sections/job/job-procedure.service';
import {CompleteRequest} from '../../models/completeRequest';
import {GenericModalComponent} from '../generic-modal/generic-modal.component';

@Component({
  selector: 'procedure-form-validations-skip',
  templateUrl: './procedure-form-validations-skip.component.html',
  styleUrls: ['./procedure-form-validations-skip.component.scss', '../job-details/job-details.component.scss', '../stylesheets/job-actions.scss', '../stylesheets/job-main.scss'],
  animations: [slideUp(100), slideDown(100), fadeIn(200), fadeOut(200)]
})
export class ProcedureFormValidationsSkipComponent implements AfterViewInit {

  @ViewChild('procedureFormValidationsSkipResponseModal') public procedureFormValidationsSkipResponseModal: GenericModalComponent;
  @ViewChild('procedureFormValidationsSkipResponseModalError') public procedureFormValidationsSkipResponseModalError: GenericModalComponent;

  public isLoading = false;
  public self = this;
  public jobProcedureFormValidationsSkipRequestDetails: JobProcedureFormValidationsSkipRequestDetails;
  public readonly ButtonIcons = ButtonIcons;

  constructor(
      private route: ActivatedRoute,
      private router: Router,
      private jobProcedureService: JobProcedureService
  ) {
    this.jobProcedureFormValidationsSkipRequestDetails = this.route.snapshot.data.procedureFormValidationsSkipDetails as JobProcedureFormValidationsSkipRequestDetails;
  }

  get formattedFormName(): string {
    const {listOrder, formName} = this.jobProcedureFormValidationsSkipRequestDetails.requestDetails || {};
    return listOrder && formName ? `[Step ${listOrder}] ${formName}` : '';
  }

  ngAfterViewInit(): void {
    GlobalSettingsService.isGlobalLoaderLoading = false;
    GlobalSettingsService.isSecondaryLoaderLoading = false;
  }

  public navigateWithData(subpage: string): void {
    this.router.navigate([subpage], { relativeTo: this.route, state: { jobProcedureFormValidationsSkipRequestDetails: this.jobProcedureFormValidationsSkipRequestDetails } });
  }

  public submitApprove(): void{
    this.isLoading = true;

    const updateRequestModel: CompleteRequest  = {
        isApproved: true,
        comment : null
    };

    this.jobProcedureService.updateJobProcedureFormValidationsSkipRequest(this.route.snapshot.paramMap.get('token'), updateRequestModel)
        .subscribe(
        () => {
            GlobalSettingsService.isSecondaryLoaderLoading = false;
            this.procedureFormValidationsSkipResponseModal.open();
            this.isLoading = false;
        },
        () => {
          GlobalSettingsService.isSecondaryLoaderLoading = false;
          this.procedureFormValidationsSkipResponseModalError.open();
        });
  }

  public closeProcedureFormValidationsSkipResponseModal(){
    this.procedureFormValidationsSkipResponseModal.hide();

    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

}
